export const ErrorStore = {
    namespaced: true,
    state: {
        errors: [],
    },
    mutations: {
        //Type
        ADD_ERROR(state, payload) {
            state.errors.push(payload);
        },
    },
    actions: {
        add({ commit }, payload) {
            commit("ADD_ERROR", [new Date().toLocaleTimeString(), payload])
        }
    }
}